import { USER_FORM } from '../form-portaluser-type';
import WpResetPasswordLink from '../../../../routes/send-password-reset';

/**
 * Resets the password for the selected user.
 * 
 * @returns void
 */
const HandlePasswordReset = (userID: string) => {
    const resetButton = document.getElementById('aafp_reset-password') as HTMLButtonElement;
    if(!resetButton) return;

    const handleReset = async () => {
        resetButton.classList.add('aafp_button-loading');
        const response = await WpResetPasswordLink(USER_FORM.userName.value, userID);

        if (response.statusCode === 200) {
            alert('Password reset email sent');
            resetButton.classList.remove('aafp_button-loading');
        } else {
            alert('Error sending password reset email');
        }
    }

    resetButton.addEventListener('click', handleReset);
};

export default HandlePasswordReset;